// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__q0haL","skillsContainer":"Skills_skillsContainer__QwLPw","skills":"Skills_skills__MHPZg"};